import { Card, Space, Spin, Typography, } from "antd";

import { graphql } from "@/__graphql__";
import { useQuery } from "urql";
import { LocationsMap } from "../../components/LocationsMap";

export function LocationsMapScreen() {
  const [{ data, fetching }] = useQuery({ query: RelationQuery });

  const relation = data?.relation;
  const locations = data?.relation?.locations ?? [];

  if (relation === undefined || relation === null) {
    return <Spin size="large" />;
  }

  return (
    <Space orientation="vertical" style={{ width: "100%" }}>
      <Card size="small">
        {relation.defaultAreaCoverageInMeters !== undefined && (
          <Typography>Dekking per locatie: {relation.defaultAreaCoverageInMeters}m.</Typography>
        )}
      </Card>
      <LocationsMap
        defaultAreaCoverageInMeters={relation.defaultAreaCoverageInMeters ?? undefined}
        locations={locations}
        style={{
          borderRadius: "4px",
          height: "calc(100vh - 300px)",
          width: "100%"
        }}
      />
    </Space>
  );
}


const RelationQuery = graphql(`
  query LocationsMap__LocationsMap__RelationQuery {
    relation {
      id
      name
      afasCode
      defaultAreaCoverageInMeters
      locations {
        id
        name
        address {
          street
          postalCode
          city
          country
          coordinates {
            latitude
            longitude
          }
        }
      }
    }
  }
`);
